import request from '@/utils/request'
const qs = require('qs')
export function listPerProductStoreSatuan(data) {
  return request({
    url: '/report_persediaan/list_per_product_store_satuan',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listGudangHasTransactions(data) {
  return request({
    url: '/report_persediaan/list_gudang_has_transactions',
    method: 'GET',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listProbabilitas(data) {
  return request({
    url: '/report_persediaan/list_probabilitas',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listStokTerkini(data) {
  return request({
    url: '/report_persediaan/list_stok_terkini',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listMutasiStok(data) {
  return request({
    url: '/report_persediaan/list_mutasi_stock',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listPareto(data) {
  return request({
    url: '/report_persediaan/list_pareto',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listMinimalStock(data) {
  return request({
    url: '/report_persediaan/list_minimal_stock',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function listStockHabis(data) {
  return request({
    url: '/report_persediaan/list_data_stock_habis',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/reportInventory.js